










































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import EmptyData from '../../EmptyData/EmptyData.vue'
import { FullDistribution } from '../Distribution'
import { DistributionState } from '../DistributionEditor/types'
import DistributionCard from './components/DistributionCard.vue'
import DistributionsFilters from './components/DistributionsFilters.vue'

@Component({
  components: {
    DistributionCard,
    DistributionsFilters,
    EmptyData
  }
})
export default class DistributionsList extends Vue {
  @Prop() getDistributions!: (state: null | DistributionState, offset: number) => Promise<Array<FullDistribution>>

  @Prop() goToDistribution!: (id: string) => void

  @Prop() goToCopyDistribution!: (id: string) => void

  @Prop() goToEditDistribution!: (id: string) => void

  @Prop() cancelDistribution!: (id: number) => Promise<void>

  @Watch('activeStateFilter')
  stateFilterWatcher(filter: null | DistributionState): void {
    this.getDistributions(filter, 0)
      .then((distributions) => {
        this.distributions = distributions

        this.loadIsPosible = distributions.length >= 10;
      })
  }

  activeStateFilter: null | DistributionState = null

  distributions: Array<FullDistribution> = []

  loadIsPosible = true

  get paginationOffset(): number {
    return !this.distributions ? 0 : this.distributions.length
  }

  cancelDistributionHandler(id: number): void {
    this.cancelDistribution(id)
      .then(() => {
        this.getDistributions(this.activeStateFilter, 0)
          .then(res => this.distributions = res)
      })
  }

  loadMore(): void {
    if (this.loadIsPosible) {
      this.getDistributions(this.activeStateFilter, this.paginationOffset)
        .then((distributions) => {
          this.distributions.push(...distributions)

          if (distributions.length < 10) {
            this.loadIsPosible = false
          }
        })
    }
  }

  created(): void {
    this.getDistributions(null, 0).then((distributions) => this.distributions = distributions)
  }
}
